import { getSupplier, getVenuePackages } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { getPackagesPrice } from '@bridebook/web/app-shared/lib/supplier/utils';

const useHasPrice = () => {
  const packages = useSelector(getVenuePackages);
  const supplier = useSelector(getSupplier);
  const basePrice = useSelector((state) => state.supplier.supplier?.pricing?.base);
  const maxPrice = useSelector((state) => state.supplier.supplier?.pricing?.maximum);
  const info = useSelector((state) => state.supplier.supplier?.pricing?.description);

  const venueHireOnlyMinPrice = getPackagesPrice('venueHire', 0, packages);
  const venueHireOnlyMaxPrice = getPackagesPrice('venueHire', 1, packages);
  const packagesMinPricePp = getPackagesPrice('pricePerHead', 0, packages);
  const packagesMaxPricePp = getPackagesPrice('pricePerHead', 1, packages);
  const packagesTotalCostMinPrice = getPackagesPrice('totalInclusive', 0, packages);
  const packagesTotalCostMaxPrice = getPackagesPrice('totalInclusive', 1, packages);
  const minPrice = supplier?.pricing?.base;

  return (
    venueHireOnlyMinPrice > 0 ||
    venueHireOnlyMaxPrice > 0 ||
    packagesMinPricePp > 0 ||
    packagesMaxPricePp > 0 ||
    packagesTotalCostMinPrice > 0 ||
    packagesTotalCostMaxPrice > 0 ||
    minPrice === 0 ||
    (basePrice && basePrice > 0) ||
    (maxPrice && maxPrice > 0) ||
    info !== undefined
  );
};

export { useHasPrice };
